<template>
  <div class="content">
    <el-tabs type="border-card">
      <el-tab-pane class="tab-pane" label="基本信息">
        <el-form :model="form">
          <el-form-item label="门店编号" class="notreq">
            <el-input
              v-if="renderStoreNum()"
              class="storeinput input1"
              v-model="form.inputNum"
              :disabled="DisabledRnder()"
              placeholder="最多输入10位"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="reqform"
            label="药店名称"
            prop="inputName"
            :rules="[{ required: true, message: '请输入药店名称', trigger: 'blur' }]"
          >
            <el-input
              v-if="renderStoreNum()"
              class="storeinput input2"
              v-model="form.inputName"
              :disabled="DisabledRnder()"
              @blur="detection"
              placeholder="最多输入30个字"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="门店地址" class="address_form" :rules="[{ required: true }]">
            <div class="addbar">
              <area-select ref="area_select" :disabled="DisabledRnder()"></area-select>
            </div>
            <div class="extadd">
              <el-input
                v-if="renderStoreNum()"
                v-model="form.inputArea"
                placeholder="最多输入30个字"
                :disabled="DisabledRnder()"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item label="门店坐标" class="amap_form" :rules="[{ required: true }]">
            <!-- 地图插件 -->
            <div class="amap-wrap">
              <el-amap
                ref="amap"
                vid="amap-vue"
                v-if="center.length > 0"
                :center="center"
                :zoom="amap.zoom"
                :plugin="amap.plugin"
                :events="amap.events"
              >
                <div class="search-box" v-if="canUpdateDistance">
                  <el-input
                    v-model="searchWord"
                    placeholder="搜索地址"
                    @input="onSearchInput"
                    @keyup.enter.native="onSearchResult()"
                    size="small"
                    class="search-input"
                  ></el-input>
                  <!-- <el-button
                    icon="el-icon-search"
                    size="small"
                    class="btn btn-search"
                    @click="onSearchResult()"
                  ></el-button> -->
                  <div class="search-icon-wrap" @click="onSearchResult()">
                    <i class="el-icon-search"></i>
                    <div class="line"></div>
                  </div>
                  <el-button type="primary" size="small" class="btn btn-sure" @click="onSave">确定坐标</el-button>

                  <!-- <el-button
                    icon="el-icon-search"
                    type="text"
                    circle
                    class="search-icon"
                    @click="onSearchResult()"
                  ></el-button> -->
                  <div class="search-tips" v-if="searchList.length && showSearchList">
                    <div class="tips" v-for="(item, index) in searchList" :key="index" @click="onSearchResult(item.id)">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
                <!-- <el-amap-info-window
                  class="info-window window1"
                  v-if="center.length > 0"
                  isCustom="true"
                  :offset="infoWindow[1].offset"
                  :visible="infoWindow[1].visible"
                  :position="center"
                >
                  <amap-info-window :address="content" @onSave="onSave" @onCancel="onCancel"></amap-info-window>
                </el-amap-info-window> -->
                <!-- <el-amap-info-window
                  class="info-window window2"
                  isCustom="true"
                  :offset="infoWindow[0].offset"
                  :visible="infoWindow[0].visible"
                  :position="center"
                >
                  <div class="content-wrap">
                    <span class="address">{{ content }}</span>
                    <span
                      class="check"
                      style="color: #1E8DFF; margin-left: 12px; border-bottom: 1px solid #1E8DFF; user-select: none"
                      @click="showWindow('window2')"
                    >
                      可拖拽调整位置
                    </span>
                  </div>
                </el-amap-info-window> -->
                <el-amap-info-window
                  class="info-window window2"
                  isCustom="true"
                  :offset="infoWindow[0].offset"
                  :visible="infoWindow[0].visible"
                  v-if="showInfoWindow"
                  :position="center"
                >
                  <div class="content-wrap">
                    <span class="address">{{ content }}</span>
                    <!-- <span v-if="canUpdateDistance" class="check drag-text">
                      可拖拽调整位置
                    </span> -->
                  </div>
                </el-amap-info-window>
                <el-amap-marker
                  v-if="center.length > 0"
                  :draggable="marker.draggable"
                  :position="center"
                  :events="marker.events"
                ></el-amap-marker>
              </el-amap>
              <div class="toolbar"></div>
            </div>
            <div class="map-info">
              注：门店坐标一年仅可修改{{ distanceCount }}次，您已修改
              <span class="num">{{ distanceUpdateCount }}/{{ distanceCount }}</span>
              次
            </div>
          </el-form-item>

          <div class="photo_area">
            <span class="text">营业执照</span>
            <div class="upload">
              <img-upload ref="imgUp" :disabled="DisabledRnder()"></img-upload>
            </div>
          </div>
          <div class="submit global_common_button_main" @click="getAdd" v-if="photo_areaRender()">
            <span>提</span>
            <span>交</span>
          </div>
          <el-tooltip v-if="disabledBtnRender()" class="item" effect="dark" content="该店铺正在审核" placement="top">
            <div class="submit disab">
              <span>提</span>
              <span>交</span>
            </div>
          </el-tooltip>

          <div class="print" v-if="renderStoreQrcode()">
            <span>打印二维码</span>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane class="tab-pane" label="扫码问诊物料" v-if="scanQrWenzhen">
        <qrcode
          :guidelineUrl="guidelineUrl"
          :storeName="form.inputName"
          :storeSupervision="storeSupervision"
          :store-qr-list="storeQrList"
        ></qrcode>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue';
import AMapJs from 'amap-js';
import VueAMap from 'vue-amap';
import { pcaa } from 'area-data';
import areaSelect from '@/components/global/form/areaSelect';
import { Input, Upload, Dialog, Tooltip, Form, FormItem, Tabs, TabPane, Button } from 'element-ui';
import imgUpload from '@/components/shopManagement/upload';
import amapInfoWindow from '@/components/shopManagement/amapInfoWindow';
import qrcode from '@/components/shopManagement/qrcode';
import Fetch from '@/api/index';
import debounce from 'lodash/debounce';
Vue.use(Upload);
Vue.use(Input);
Vue.use(Dialog);
Vue.use(Tooltip);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Button);

// 初始化地图插件 start
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: process.env.VUE_APP_AMAP_KEY,
  // plugin: ['AMap.ToolBar', 'AMap.Geolocation', 'AMap.Geocoder'],
  v: '1.4.4'
});
// end

export default {
  props: ['type'], // type 1 为添加门店

  data() {
    const self = this;
    return {
      form: {
        inputNum: '', // 门店编号
        inputName: '', // 门店名称
        inputArea: '' // 门店地址
      },
      storeSupervision: {}, // 门店关联监管信息
      sendFlag: false,
      storeStatus: null, // 门店状态 给type==2使用
      searchWord: '',
      searchList: [], // 搜索联想窗口
      showSearchList: false,
      scanQrWenzhen: 0,
      guidelineUrl: '', // 用户手册地址
      wxQrUrl: '', // 桌面二维码
      wxQrPostUrl: '', // 海报二维码
      medicalQrUrl: '', // 医保二维码
      storeQrList: [], // 二维码数组
      content: '', // 文字地址
      // 初始地址 后端返回的
      defaultCenter: [],
      defaultAdress: '',
      defaultCity: '北京',
      // 当前地址 未保存后端
      center: [],
      // 标记点配置
      marker: {
        draggable: true,
        events: {
          dragend: self.onDragend
        }
      },
      // 地图插件配置
      amap: {
        zoom: 14,
        plugin: [
          {
            pName: 'AMap.ToolBar',
            position: 'RB',
            liteStyle: true,
            locate: true,
            events: {
              location(result) {
                console.log('location = ', location);
                const {
                  lnglat: { lng, lat }
                } = result;
                self.setContent({
                  center: [lng, lat],
                  isSave: true
                });
              }
            }
          }
        ],
        events: {
          // init(o) {
          //   o.setMapStyle('amap://styles/macaron'); //自定义的高德地图的样式，我选的是马卡龙
          // }
        }
      },
      // 悬浮窗配置
      infoWindow: [
        {
          visible: true,
          offset: [0, -40]
        },
        {
          visible: true,
          offset: [0, -40]
        }
      ],
      distanceUpdateCount: 1,
      distanceCount: 1,
      showInfoWindow: true
    };
  },
  computed: {
    canUpdateDistance() {
      return this.distanceUpdateCount < this.distanceCount;
    }
  },
  components: {
    areaSelect,
    imgUpload,
    amapInfoWindow,
    qrcode
  },
  async created() {
    this.getStoreSupervision();
    await this.initStoreDistance();
  },
  mounted() {
    if (this.type == 2) {
      // 查看门店
      this.getStoreMessage();
    }
    if (this.type == 3) {
      this.getEditorMessage();
    }
  },
  methods: {
    async getStoreSupervision() {
      try {
        //  /api/amikacin/1.0/store_supervision
        this.storeSupervision = (await Fetch.get_store_supervision({ storeId: this.$route.params.shopId })) || {};
      } catch (err) {}
    },
    async initStoreDistance() {
      let res = await Fetch.select_store_longitudeLatitude({ id: this.$route.params.shopId });
      const { updateCount, count } = res;
      console.log('updateCount = ', { updateCount, count });
      this.distanceUpdateCount = updateCount;
      this.distanceCount = count;
      this.marker.draggable = this.canUpdateDistance;
      // this.$set(this.amap.plugin[0], 'locate', this.canUpdateDistance);
      if (!this.canUpdateDistance) {
        // 重新渲染一下地理位置的infoWindow
        this.showInfoWindow = false;
        this.$nextTick(() => {
          this.showInfoWindow = true;
        });
      }
    },
    $getCenter() {
      const { center, defaultCenter } = this;
      return {
        center,
        defaultCenter,
        equal: !this.canUpdateDistance || center.join('') === defaultCenter.join('')
      };
    },
    // 地图初始化
    async initAMap(defaultLocation) {
      const AMapLoader = new AMapJs.AMapLoader({
        key: process.env.VUE_APP_AMAP_KEY,
        version: '1.4.4',
        security: {
          securityJsCode: process.env.VUE_APP_AMAP_SECRET
        }
      });
      try {
        const map = await AMapLoader.load();
        await AMapLoader.loadPlugin([
          'AMap.Geocoder',
          'AMap.ToolBar',
          'AMap.Geolocation',
          'AMap.Autocomplete',
          'AMap.PlaceSearch'
        ]);
      } catch (error) {
        console.log('加载定位组件失败', error);
        this.$message.error('加载定位组件失败');
        Telescope.trackEvent({
          trackId: 'zywzpc-click-error-loadamap',
          custom: {
            data: JSON.stringify(error)
          }
        });
        return;
      }
      this.geocoder = new AMap.Geocoder({
        extensions: 'all'
      });
      this.geolocation = new AMap.Geolocation({
        timeout: 10000, // 设置定位超时时间，默认：无穷大
        zoomToAccuracy: true //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见
      });
      this.autoComplete = new AMap.Autocomplete({ citylimit: false });
      this.placeSearch = new AMap.PlaceSearch();
      // 优先定位后端保存的地址 否则自动定位
      if (defaultLocation) {
        this.defaultCenter = defaultLocation.split(',');
        this.setContent({
          center: this.defaultCenter
        });
      } else this.getBrowserLocation();
    },
    onSave() {
      this.$confirm(
        `确认修改吗？门店坐标一年仅可修改${this.distanceCount}次，您当前剩余可修改${
          this.distanceCount - this.distanceUpdateCount
        }次；`,
        '提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          customClass: 'confirm',
          center: true
        }
      )
        .then(async () => {
          this.defaultCenter = this.center;
          await this.updateStore({ longitudeLatitude: this.center.join(',') });
          this.$nextTick(() => {
            this.initStoreDistance();
          });
        })
        .catch(() => {});

      // this.showWindow();
    },
    onCancel() {
      this.setContent({
        center: this.defaultCenter
      });
      // this.showWindow();
    },
    // // 切换信息悬浮窗
    // showWindow(className = 'window1') {
    //   this.infoWindow = [
    //     {
    //       ...this.infoWindow[0],
    //       visible: className === 'window1'
    //     },
    //     {
    //       ...this.infoWindow[1],
    //       visible: className === 'window2'
    //     }
    //   ];
    //   this.marker = {
    //     ...this.marker,
    //     draggable: className === 'window2'
    //   };
    // },
    // 地图插件 - 拖动marker回调
    onDragend(e) {
      console.log('onDragend  e = ', e);
      const { lng, lat } = e.lnglat;
      this.setContent({
        center: [lng, lat]
      });
      this.searchWord = '';
      this.searchList = [];
    },
    // 地图插件 - 搜索地址回调
    onSearchResult: debounce(function (placeId = this.placeId) {
      //  没有键入搜索关键字
      if (!this.searchWord) return;

      Telescope.trackEvent({ trackId: 'zywzpc-location-onSearchResult' });

      // 没有搜索联想结果
      if (!this.searchList.length) {
        this.$message.error('未定位到该地址，请检查地址信息');
        return;
      }
      this.searchPlace(placeId)
        .then(data => {
          const { name, location: center } = data;
          this.searchWord = name;
          this.placeId = placeId;
          this.setContent({
            center,
            address: name,
            isSave: true
          });
          this.showSearchList = false;
        })
        .catch(() => {
          this.$message.error('未定位到该地址，请检查地址信息');
        });
    }, 600),
    onSearchInput: debounce(function () {
      Telescope.trackEvent({ trackId: 'zywzpc-location-onSearchInput' });
      this.autoComplete.search(this.searchWord, (status, result) => {
        if (status === 'complete' && result.count) {
          const { tips } = result;
          this.searchList = tips;
          this.placeId = tips[0].id;
          this.showSearchList = true;
        } else {
          this.searchList = [];
        }
      });
    }, 500),
    // 地图插件 - 设置信息窗口的内容
    async setContent({ address, center, isSave }) {
      this.center = center;
      if (address) {
        this.content = address;
      } else {
        try {
          Telescope.trackEvent({ trackId: 'zywzpc-location-setContent' });
          const add = await this.getAddress(this.center);
          const {
            pois: [{ name }],
            addressComponent: { citycode }
          } = add.regeocode;
          this.content = name;
          this.autoComplete.setCity(citycode);
        } catch (error) {
          this.$message.error('未定位到该地址，请检查地址信息');
          this.getBrowserLocation();
        }
      }
      // isSave && this.onSave();
    },
    // 地图插件 - 经纬度转地址
    getAddress(location) {
      return new Promise((resolve, reject) => {
        this.geocoder.getAddress(location, (status, result) => {
          if (status === 'complete' && result.regeocode) {
            resolve(result);
          } else {
            reject(new Error());
          }
        });
      });
    },

    // 地图插件 - 地址转经纬度
    getLocation(address) {
      return new Promise((resolve, reject) => {
        this.geocoder.getLocation(address, (status, result) => {
          if (status === 'complete' && result.geocodes) {
            const {
              location: { lng, lat }
            } = result.geocodes[0];
            resolve([lng, lat]);
          } else {
            reject(new Error());
          }
        });
      });
    },

    // 地图插件 - 根据搜索提示id搜索地址
    searchPlace(placeId) {
      return new Promise((resolve, reject) => {
        this.placeSearch.getDetails(placeId, (status, result) => {
          if (status === 'complete' && result.poiList && result.poiList.pois?.length > 0) {
            const {
              name,
              location: { lng, lat }
            } = result.poiList.pois[0];
            resolve({
              name,
              placeId,
              location: [lng, lat]
            });
          } else {
            reject(new Error());
          }
        });
      });
    },

    // 发起浏览器定位
    getBrowserLocation() {
      this.geolocation.getCurrentPosition(async (status, result) => {
        if (status === 'complete') {
          const {
            position: { lng, lat },
            addressComponent: { citycode }
          } = result;
          this.autoComplete.setCity(citycode);
          this.setContent({
            center: [lng, lat],
            isSave: true
          });
        } else {
          console.log('定位失败', result);
          this.$message.error('定位失败, 请手动定位');
          this.center = [120.160039, 30.227197];
          Telescope.trackEvent({
            trackId: 'zywzpc-click-error-geolocation',
            custom: {
              data: JSON.stringify(result)
            }
          });
        }
        // else if (this.provinceCode) {
        //   // 获取定位失败取crm地址
        //   this.setContent({
        //     center: await this.getLocation(pcaa[this.provinceCode][this.cityCode])
        //   });
        // } else {
        //   // 没有crm地址取北京
        //   this.setContent({
        //     center: await this.getLocation(this.defaultCity)
        //   });
        // }
      });
    },

    detection() {
      console.log('检测');
    },
    photo_areaRender() {
      if (this.type == 1) {
        return true;
      }
      if (this.type == 3) {
        return true;
      }
    },
    async getEditorMessage() {
      // 获取编辑模式数据
      const shopId = this.$route.params.shopId;
      let res = await Fetch.get_store_fromId({
        id: shopId
      });
      this.form.inputNum = res.storeNo;
      this.form.inputName = res.name;
      this.form.inputArea = res.address || '未填写';
      this.storeStatus = res.status; // 方便调试使用 用完把2删了
      this.form.businessLicenceUrl = res.businessLicenceUrl;
      this.$refs.imgUp.setImg(this.form.businessLicenceUrl);
      this.$refs.area_select.setDefault({
        provinceValue: res.provinceCode,
        cityValue: res.cityCode,
        areaValue: res.distrCode
      });
    },
    async getStoreMessage() {
      const shopId = this.$route.params.shopId;
      let res =
        (await Fetch.get_store_fromId({
          id: shopId
        })) || {};

      // 用解构改写 避免多次点调用
      const {
        longitudeLatitude,
        storeNo: inputNum = '',
        name: inputName,
        address: inputArea = '未填写',
        businessLicenceUrl,
        status,
        provinceCode,
        cityCode,
        distrCode,
        wxQrUrl,
        wxQrPostUrl,
        storeQrList,
        guidelineUrl,
        scanQrWenzhen,
        medicalQrUrl
      } = res;

      // 初始化地图插件
      this.initAMap(longitudeLatitude);
      // 有小程序问诊的药店，提示

      this.$confirm('为了确保您顺利使用问诊服务，请您保持门店地图坐标与实际门店位置一致', '提示', {
        confirmButtonText: '确定',
        customClass: 'alert',
        center: true,
        showCancelButton: false
      })
        .then(() => {})
        .catch(() => {});

      this.wxQrUrl = wxQrUrl; // 扫码问诊 桌面二维码
      this.wxQrPostUrl = wxQrPostUrl; // 扫码问诊 海报二维码
      this.guidelineUrl = guidelineUrl; // 扫码问诊 用户操作手册
      this.medicalQrUrl = medicalQrUrl; // 医保二维码
      this.scanQrWenzhen = scanQrWenzhen; // 扫码问诊 药店是否开启扫码问诊
      this.provinceCode = provinceCode; // crm地址 获取浏览器地址失败使用
      this.cityCode = cityCode; // crm地址 获取浏览器地址失败使用
      this.storeQrList = storeQrList;

      this.form = {
        inputNum,
        inputName,
        inputArea,
        businessLicenceUrl
      };

      this.storeStatus = status; // 方便调试使用 用完把2删了
      this.$refs.imgUp.setImg(businessLicenceUrl);

      this.$refs.area_select.setDefault({
        provinceValue: provinceCode,
        cityValue: cityCode,
        areaValue: distrCode
      });
    },

    // 以往逻辑未知 新增一个更新店铺信息方法 用来更新经纬度
    async updateStore(formData) {
      const shopId = this.$route.params.shopId;
      if (formData.longitudeLatitude == [120.160039, 30.227197].join(',')) {
        return this.$message.warning('请先选择店铺位置');
      }
      await Fetch.update_store_location({ ...formData, id: shopId });
      this.$message.success('更新门店位置成功');
    },
    DisabledRnder() {
      if (this.type == 2) {
        return true;
      }
      return false;
    },
    renderStoreNum2() {
      if (this.type == 2) {
        return true;
      }
      return false;
    },
    renderStoreNum() {
      return true;
      // }
    },
    renderImg() {
      // 渲染营业执照 查看门店信息时才会显示
      if (this.type == 2) {
        return true;
      }
    },
    disabledBtnRender() {
      // 不可点击的提交按钮显示逻辑
      if (this.type == 2) {
        if (this.storeStatus == 2) {
          return true;
        }
      }
    },

    renderStoreQrcode() {
      return false;
      /* if (this.type == 1) {
        return false;
      }
      if (this.type == 2) {
        if (this.storeStatu == 1) {
          // 查看门店 并且当前门店已通过审核
          return true;
        }
      }
      return false; */
    },
    getAdd() {
      let formData = this.queryForm();

      if (formData.name == '') {
        this.$message.error('药店名称不能为空');
        return;
      }
      if (formData.address == '') {
        // this.$message.error('药店地址不能为空');
        // return;
      }
      if (formData.provinceCode == '' || formData.distrCode == '' || formData.cityCode == '') {
        this.$message.error('药店省、市、区不能为空');
        return;
      }

      if (formData.businessLicenceUrl == '' || !formData.businessLicenceUrl) {
        this.$message.error('药店执照不能为空');
        return;
      }
      if (this.sendFlag) {
        this.$message('正在添加中');
      }
      this.sendFlag = true;
      this.postMessage(formData);
    },
    postMessage(formData) {
      const _this = this;
      if (this.type == 1) {
        // 添加
        Fetch.insert_store(formData)
          .then(res => {
            this.$message('门店添加成功，我们会尽快为您进行审核');
            this.sendFlag = false;
            _this.$router.push('/shopManagement');
          })
          .catch(e => {
            this.sendFlag = false;
          });
        return;
      }

      if (this.type == 3) {
        // 编辑
        const shopId = this.$route.params.shopId;
        Fetch.update_store({ ...formData, id: shopId })
          .then(res => {
            this.sendFlag = false;
            this.$message('已提交');
            this.$router.push('/shopManagement');
          })
          .catch(e => {
            this.sendFlag = false;
          });
      }
    },
    queryForm() {
      // 取数据过滤
      let areaCode = this.$refs.area_select.getArea(); // 获取行政区选择
      let getUploadImg = this.$refs.imgUp.getUploadImg(); // 获取营业执照
      let storeNo = this.form.inputNum;
      let name = this.form.inputName;
      let address = this.form.inputArea;
      let businessLicenceUrl = getUploadImg;
      let provinceCode = areaCode.provinceValue;
      let cityCode = areaCode.cityValue;
      let distrCode = areaCode.areaValue;
      const submitData = {
        storeNo,
        name,
        address,
        provinceCode,
        distrCode,
        cityCode,
        businessLicenceUrl
      };
      return submitData;
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 634px;
  .input1 {
    width: 176px;
  }
  .input2 {
    width: 464px;
  }
  /deep/.el-tabs {
    box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
    border-radius: 4px;
    border: 1px solid rgba(242, 242, 242, 1);
    .el-tabs__content {
      padding-top: 20px;
    }
    .el-tabs__header {
      background-color: #fff;
      border-bottom-color: #f2f2f2;
      .el-tabs__item {
        color: #bdbdbd;
        background-color: #fafafa;
        &:hover {
          color: #707070;
        }
        &.is-active {
          color: #1e8dff;
          border-right-color: #f2f2f2;
          border-left-color: #f2f2f2;
          background-color: #fff;
        }
      }
    }
  }
  .must {
    &:after {
      content: '*';
      display: block;
      position: absolute;
      color: #f56c6c;
      font-size: 14px;
      left: 0px;
      top: 11px;
    }
  }
  .storeName,
  .storeAddress,
  .photo_area {
    @extend .must;
    padding-left: 10px;
  }
  .storeNum,
  .storeName {
    display: flex;

    input::-webkit-input-placeholder {
      color: #bdbdbd;
      font-size: 14px;
    }
    input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #bdbdbd;
      font-size: 14px;
    }
    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #bdbdbd;
      font-size: 14px;
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #bdbdbd;
      font-size: 14px;
    }
  }
  .mtop {
    margin-top: 16px;
    .text {
      padding-top: 13px;
      margin-right: 16px;
      color: #707070;
      font-size: 14px;
    }
  }
  .storeNum,
  .storeName,
  .storeAddress,
  .photo_area {
    @extend .mtop;
    position: relative;
  }
  .storeAddress {
    display: flex;
  }
  .extadd {
    padding-top: 10px;
    .el-input {
      width: 464px;
    }
  }
  .map-info {
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bfbfbf;
    line-height: 28px;
    .num {
      color: #1e8dff;
    }
  }
  .amap-wrap {
    width: 464px;
    height: 262px;
    position: relative;
    background-color: #eee;
    .search-icon-wrap {
      background: #fff;
      height: 32px;
      width: 42px;
      color: #1e8dff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .line {
        position: absolute;
        height: 0;
        width: 20px;
        transform-origin: center center;
        border: 1px solid #f2f2f2;
        transform: rotate(90deg);
        left: -10px;
      }
    }
    .search-box {
      width: 440px;
      height: 32px;
      position: absolute;
      top: 11px;
      left: 12px;
      font-size: 14px;
      color: #fff;
      display: flex;
      .search-input {
        background: #fff;
        line-height: 0;
        border-radius: 0;
        // width: 320px;
        // padding-left: 20px;
        // height: 32px;
        // background-color: #fff;
        // border-radius: 32px;
        // position: relative;
        /deep/.el-input__inner {
          // height: 32px;
          border: none;
          // position: absolute;
          // top: 0;
          // width: 400px;
        }
      }
      // /deep/.el-button--text {
      //   color: #bdbdbd;
      //   &:hover {
      //     color: #bdbdbd;
      //   }
      // }
      .btn {
        border-radius: 0;
        border: none;
      }
      .btn-search {
        background: #fff !important;
      }
      /deep/ .el-button + .btn-sure {
        margin-left: 0 !important;
      }
      .search-icon {
        position: absolute;
        left: 0;
        top: 0;
        width: 32px;
        height: 32px;
        line-height: 32px;
        padding: 0;
      }
      .search-tips {
        position: absolute;
        top: 37px;
        left: 0;
        width: 176px;
        height: 161px;
        border-radius: 4px;
        background-color: #fff;
        color: #242424;
        font-size: 12px;
        overflow-y: auto;
        z-index: 10000;
        .tips {
          height: 32px;
          line-height: 32px;
          padding-left: 11px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          &:hover {
            background-color: #fafafa;
            color: #1e8dff;
          }
        }
      }
    }
    .search-box-wrapper {
      border-radius: 50%;
      overflow: hidden !important;
    }
    .content-wrap {
      background-color: #fff;
      padding: 0 12px;
      font-size: 12px;
      color: #242424;
      // height: 28px;
      line-height: 28px;
      border-radius: 4px;

      .drag-text {
        margin-left: 6px;
        color: #1e8dff;
        user-select: none;
        text-decoration: underline;
      }
    }
  }
  .photo_area {
    display: flex;
    span {
      display: block;
      // padding-top: 10px;
    }
    .photoBox {
      img {
        display: block;
        width: 296px;
        height: 200px;
      }
    }
  }
  .submit {
    margin-top: 16px;
    width: 174px;
    height: 40px;
    // background: #1E8DFF;
    // border: 1px solid #1E8DFF;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 14px;
      // color: #fff;
      &:nth-child(1) {
        margin-right: 5px;
      }
      &:nth-child(2) {
        margin-left: 5px;
      }
    }
  }
  .disab {
    cursor: not-allowed;
    background: #e6e6e6;
    border-radius: 4px;
    border: none;
    span {
      font-size: 14px;
      color: #bdbdbd;
    }
  }
  .print {
    margin-top: 16px;
    width: 174px;
    height: 40px;
    background: #1e8dff;
    border: 1px solid #1e8dff;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 14px;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.address_form,
.amap_form {
  // overflow: hidden;
  .el-form-item__label {
    float: left !important;
  }
  .el-form-item__content {
    float: left !important;
  }
}
.notreq {
  .el-form-item__label {
    padding-left: 10px;
  }
}
.reqform {
  .el-form-item__error {
    left: 90px;
  }
}
</style>
